var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHibooks3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 464,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "32.0 24.0 448.0 464.0",
    width: 448,
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "change1_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 24H376V440H56z",
    fill: "#e3e4e2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "change2_1"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0093b9",
    height: 304,
    rx: 24,
    width: 224,
    x: 256,
    y: 184
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "change3_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288 296H320V328H288z",
    fill: "#f6bc1b"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "change3_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352 296H384V328H352z",
    fill: "#f6bc1b"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "change4_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288 216H448V264H288z",
    fill: "#56c3c1"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "change3_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416 296H448V328H416z",
    fill: "#f6bc1b"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "change3_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288 360H320V392H288z",
    fill: "#f6bc1b"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "change3_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352 360H384V392H352z",
    fill: "#f6bc1b"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "change3_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416 360H448V392H416z",
    fill: "#f6bc1b"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "change3_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288 424H320V456H288z",
    fill: "#f6bc1b"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "change3_8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352 424H384V456H352z",
    fill: "#f6bc1b"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "change3_9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416 424H448V456H416z",
    fill: "#f6bc1b"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "change2_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320,104H48A16,16,0,0,1,32,88h0A16,16,0,0,1,48,72H320l16,16Z",
    fill: "#0093b9"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "change3_10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184,144H120a8,8,0,0,1-5.657-2.343l-32-32A8,8,0,0,1,80,104V72H96v28.687L123.313,128H184Z",
    fill: "#f6bc1b"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "change2_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88 176H216V272H88z",
    fill: "#0093b9"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "change4_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.656,244.438l-13.312-8.876,16-24a8,8,0,0,1,10.234-2.717l24.844,12.422,12.423-24.845,14.31,7.156-16,32a8,8,0,0,1-10.733,3.577l-25.683-12.841Z",
    fill: "#56c3c1"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "change5_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 296H216V312H120z",
    fill: "#b2b1b4"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "change5_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88 328H216V344H88z",
    fill: "#b2b1b4"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "change5_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88 360H216V376H88z",
    fill: "#b2b1b4"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "change5_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88 392H200V408H88z",
    fill: "#b2b1b4"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "change5_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88 296H104V312H88z",
    fill: "#b2b1b4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHibooks3);
export default __webpack_public_path__ + "static/media/hibooks3.a3a4644b896a220be339c566043cb2ea.svg";
export { ForwardRef as ReactComponent };